import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import QType from './QType'

Vue.use(Vuex)

const zhConfig = require('../../zh.config')
const isIISSubApp = zhConfig.isIISSubApp
const developPort = zhConfig.developPort
const IISSubAppRoute = zhConfig.IISSubAppRoute

// 環境為 dev 或 production
const isDev = !(process.env.NODE_ENV === 'production')

// 伺服器路徑
const server = isDev
  ? 'https://localhost:' + developPort + '/'
  : window.location.href
    .split('/')
    // set root path according to isIISSubApp
    .slice(0, 3)
    .join('/') +
  '/' +
  IISSubAppRoute +
  '/'

export default new Vuex.Store({
  state: {
    api: server + 'user/api',
    // api: '/user/api',//因為使用proxy進行修改
    // adminServer: 'http://localhost:8081',//在local端測試加入的admin端的server設定
    server,//backend的server
    loginServerEnterprise: null,
    loginServer: null,
    questM: {
      questSysId: null, // 問卷流水編號
      questTitle: '', // 問卷名稱
      questType: '', // 問卷類別
      clientUserType: '', // 指定填寫對象類型
      questStartPic: '', // 問卷起始圖片
      questDesc: '', // 問卷說明
      questAnnounce: '', // 問卷條款聲明
      questUrl: '', // 問卷位址
      questBackColor: '', // 問卷底色
      qusetThankPic: '', // 問卷感謝圖片
      qusetThank: '', // 問卷感謝文字
      questTransUrl: '', // 問卷感謝頁轉連結
      questDateStart: '', // 問卷起始日期
      questDateEnd: '', // 問卷結束日期
      questMaxNum: null, // 問卷份數上限
      isVisible: false, // 是否公開
      questNowNum: null, // 累積問卷填寫數
      googleAnalytics: '', // Google 行銷追蹤碼
      facebookPixel: '', // Fb 行銷追蹤碼
      assignCheck: '', // 指定檢核題目類型
      pageType: '' // 頁面樣式
    },
    questD: [],
    userToken: null,
    PhoneNum: null,
    // TokenResponse: {},
    QType,
    errMessage: '',
    isMobile: false,
    finished: false
  },
  mutations: {
    setFinish(state) {
      state.finished = true
    },
    // 設置手機號碼
    setPhoneNum(state, PhoneNum) {
      state.PhoneNum = PhoneNum
      // 順便為會員的手機檢核題目設置手機號碼
      state.questD.find(x => x.isAssign && x.inputCheck === '30').value = PhoneNum
    }
  },
  actions: {
    async initApp() {
      

      // check if questSysId exist
      let questSysId = this.state.questM.questSysId
      let userToken = this.state.userToken ? this.state.userToken : ''
      if (!questSysId) {
        throw '無法解析問卷編號'
      }
      // ajax init App
      let url = this.state.api + '/User/Init'
      let res = await axios.get(url, {
        params: {
          questSysId: questSysId,
          userToken
        }
      })
      window.console.log('res:')
      window.console.log(res)
      switch (res.data.resultCode) {
        case '10':
          // 把獲得的資料存進 store
          this.state.questM = res.data.questM
          this.state.questD = res.data.questD
          this.state.loginServer = res.data.loginServer
          this.state.loginServerEnterprise = res.data.loginServer_enterprise
          window.console.log(this.state.loginServer)

          if (this.state.questD) { //在private,expired,fulled的情狀下不會有questD傳入
            this.questDNext = res.data.questDNext
            let i = 0
            for (let index = 0; index < this.state.questD.length; index++) {
              const element = this.state.questD[index]
              //多選題加入確認選取數目
              if(element.questItemType === 'choiceMulti'){
                element.checkValue = null
              }
              if (element.questItemType === 'choice') { // 單選包含選項為圖片題

                if (!element.fileRoutes.length) { //圖片題沒有item，是使用fileRoutes陣列，所以用變數length是承接陣列長度資訊
                  length = element.items.length;
                } else {
                  length = element.fileRoutes.length
                }
                //加入nextCol紀錄
                element.nextCol = [null]
                for (let index2 = 0; index2 < length - 1; index2++) {
                  element.nextCol.push(null)
                }

                if (
                  i < this.questDNext.length &&
                  element.enName === this.questDNext[i].enName
                ) {
                  element.skipItem = this.questDNext[i].isUse //add skipItem value
                  for (let index2 = 0; index2 < length; index2++) {
                    if (
                      i < this.questDNext.length &&
                      element.enName === this.questDNext[i].enName &&
                      this.questDNext[i].itemOrderId === index2
                    ) {
                      element.nextCol[index2] = this.questDNext[i].nextCol
                      i++
                    }
                  }
                }
              }
            }
            //讓新加入的skipItem與nextCol可以動態變動
            this.state.questD = JSON.parse(JSON.stringify(this.state.questD))
            window.console.log('questD', this.state.questD)
          }
          


          return res
        case '01':
          throw res.data.error
        default:
          throw '未知的回傳代碼'
      }
    }
  },
  modules: {}
})
